import {createSelector} from 'reselect';
import {globalVariables} from 'src/shared/itgStep/selectors/globalVariables';
export const orderId = createSelector(
  globalVariables,
  globalVariables => globalVariables.orderId
);
